import ConfigProvider from '../Core/Configuration/ConfigProvider';
import BucketHelper from '../Core/Bucket/BucketHelper';
import NotaHelper from '../Nota/NotaHelper';
import ApiContenidosService from '../Services/ApiContenidosService';

export default class RankingMasLeidas {
    constructor(options) {
        const {
            max = 3
        } = options;
        
        this.max = max;
    }

    Load() {
        this.$module = document.querySelector('[data-module="RankingMasLeidas"]');

        if (this.$module === null)
            return;
        
        this._Fetch();
    }

    _Fetch() {
        ApiContenidosService.GetRankingSitio(this.max)
            .then(notas => this._Render(notas));
    }

    _Render(notas) {
        let notasHtml = '';

        notas.forEach((nota) => {
            notasHtml += _getNotaHtml(nota);
        });

        this.$module.innerHTML = `
            <h4 class="titulo">
                <span class="text-highlighted">
                    MÁS <b>LEÍDAS AHORA</b>
                </span>
            </h4>
            <ol class="ranking">
                ${notasHtml}
            </ol>`;
    }
}

function _getNotaHtml(nota) {
    let img = '';

    if (NotaHelper.HasImage(nota)) {
        img = `<img src="${BucketHelper.GetUrl(ConfigProvider.BucketUrl, nota.imagenes[0].src, 198)}" />`;
    }

    return `
        <li>
            <article class="nota" data-notaid="${nota.id}">
                <a href="/${nota.url}" class="figure">${img}</a>    
                <h2>
                    <a href="/${nota.url}">${nota.titulo}</a>
                </h2>   
            </article>
        </li>`;
}


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/RankingMasLeidas.js